import PropTypes from 'prop-types';
import React from 'react';
import { DropdownItem } from 'reactstrap';
import { Link } from 'gatsby';

//
// Wrap dynamic (dropdown) links in the correct markup and static items in standard list items
//
const NavigationLinkItem = ({
  source, type, name, href, fullName,
}) => (
  <>
    {(() => {
      if (type === 'dynamic') {
        return (
          <DropdownItem>
            <NavigationLink source={source} name={name} href={href} fullName={fullName} />
          </DropdownItem>
        );
      }
      return (
        <li className="nav-item">
          <NavigationLink source={source} name={name} href={href} fullName={fullName} />
        </li>
      );
    })()}
  </>
);

//
// Internal links should use the Gatsby <Link> component, while external links
// should just be a basic a href to the URL
//
const NavigationLink = ({
  source, name, href, fullName,
}) => {
  if (source === 'internal') {
    // Internal links should be filtered for their external url part
    // Build a regex to strip new.smm.org
    return (
      <Link className="nav-link" to={href} title={fullName}>
        {name}
      </Link>
    );
  }
  return (
    <a className="nav-link" href={href} title={fullName}>
      {name}
    </a>
  );
};

NavigationLinkItem.defaultProps = {
  fullName: '',
};

NavigationLinkItem.propTypes = {
  fullName: PropTypes.string,
  href: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

NavigationLink.defaultProps = {
  fullName: '',
};

NavigationLink.propTypes = {
  fullName: PropTypes.string,
  href: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
};

export default NavigationLinkItem;
